import { render } from "./AdminAddWinnner.vue?vue&type=template&id=42bc077c"
import script from "./AdminAddWinnner.vue?vue&type=script&lang=js"
export * from "./AdminAddWinnner.vue?vue&type=script&lang=js"
script.render = render

export default script